export const TranslationIdMap = '';

export const TranslationKeyMap = {
    '_11234_ADD_A_TASK': 'Add a Task',
    '_11235_TASK_TITLE': 'Task Title',
    '_11236_ADD': 'Add'
};
